module.exports = __webpack_public_path__ + "static/media/maths.59de4569.JPG";